import {
  ProvidersAction,
  fetchAllProviders,
  setAllProviders,
  setAllProvidersError,
  setIsProviderSchedulesFetching,
  setIsSearching,
  setProviderLocationHistory,
  setProviderLocationHistoryFetching,
  setProviderSchedules,
  setProviders,
} from './actions';
import { all, call, delay, put, select, takeLatest } from 'redux-saga/effects';

import { HealAPI } from '../../healApi';
import { RootState } from '../types';
import { setProvider, UIAction } from '../ui/actions';
import { fetchAllProviders as fetchAllProvidersApi, fetchProviderLocationHistory } from '../../api/providers';

function* handleProviderSearchChanged(): any {
  yield delay(250);
  const state: RootState = yield select((s) => s);
  yield put(setIsSearching(true));
  const result = yield call(HealAPI.searchProvider, state.providers.searchText);
  yield put(setProviders(result.data));
  yield put(setIsSearching(false));
}

export function* providersSearchFlow(): any {
  yield takeLatest(ProvidersAction.PROVIDER_SEARCH_CHANGED, handleProviderSearchChanged);
}

function* fetchProviderSchedulesForMarketChange(market: string): any {
  const state: RootState = yield select((s) => s);
  yield put(setIsProviderSchedulesFetching(market, true));
  const result = yield call(HealAPI.fetchAllSchedules, market, state.ui.date);
  if (result.data) {
    yield put(setProviderSchedules(market, result.data.results));
  }
  yield put(setIsProviderSchedulesFetching(market, false));
}

function* fetchProviderSchedulesForMarketsChange() {
  yield put(setProvider(''));
  const state: RootState = yield select((s) => s);
  if (state.ui.markets && state.ui.markets.length > 0 && state.ui.date && state.ui.markets[0] !== 'ALL') {
    yield all(state.ui.markets.map((market) => call(fetchProviderSchedulesForMarketChange, market)));
  }
}

export function* providerSchedulesFlow() {
  yield takeLatest(['PAGE_DID_MOUNT/Visits', 'PAGE_DID_MOUNT/Map', UIAction.SET_MARKETS, UIAction.SET_DATE], fetchProviderSchedulesForMarketsChange);
}

function* fetchProviderLocationHistoryGen(): any {
  const state: RootState = yield select((s) => s);
  const { providerId, date } = state.ui;
  if (providerId) {
    yield put(setProviderLocationHistoryFetching(providerId, true));
    const data = yield call(fetchProviderLocationHistory, providerId, date);
    yield put(setProviderLocationHistory(providerId, data));
    yield put(setProviderLocationHistoryFetching(providerId, false));
  }
}

export function* getAllProviders(): any {
  yield put(fetchAllProviders(true));
  try {
    const data = yield call(fetchAllProvidersApi);
    yield put(setAllProviders(data));
  } catch (e: any) {
    yield put(setAllProvidersError(e.message));
  }
  yield put(fetchAllProviders(false));
}

function* onProviderLocationHistoryFlow() {
  yield takeLatest(['PAGE_DID_MOUNT/Visits', 'PAGE_DID_MOUNT/Map', UIAction.SET_PROVIDER_ID, UIAction.SET_DATE], fetchProviderLocationHistoryGen);
}

function* onProviderStatusChange() {
  yield takeLatest([ProvidersAction.SET_PROVIDER_ON_CALL, ProvidersAction.SET_PROVIDER_OFF_CALL], (action: any) =>
    call(fetchProviderSchedulesForMarketChange, action.data.marketCode)
  );
}

export function* providerLocationHistoryFlow() {
  yield all([call(onProviderLocationHistoryFlow), call(onProviderStatusChange)]);
}
